// src/components/orders/OrderPagination.js

import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { TABLE_LIMITS } from '../../constants';

const OrderPagination = ({ 
  page, 
  setPage, 
  limit, 
  setLimit, 
  totalPages, 
  totalRows, 
  currentCount 
}) => {
  return (
    <div className="p-4 flex items-center justify-between border-t">
      <div className="flex items-center space-x-2">
        <Label htmlFor="limit">Show</Label>
        <select
          id="limit"
          value={limit}
          onChange={(e) => {
            setLimit(Number(e.target.value));
            setPage(1);
          }}
          className="rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
        >
          {TABLE_LIMITS.map(value => (
            <option key={value} value={value}>{value}</option>
          ))}
        </select>
        <span>entries</span>
      </div>

      <div className="flex items-center space-x-2">
        <div className="text-sm text-gray-700">
          Showing {currentCount} of {totalRows} entries
        </div>
        <Button
          onClick={() => setPage(p => Math.max(1, p - 1))}
          disabled={page === 1}
          variant="outline"
          size="sm"
        >
          Previous
        </Button>
        <span className="px-4">
          Page {page} of {totalPages}
        </span>
        <Button
          onClick={() => setPage(p => Math.min(totalPages, p + 1))}
          disabled={page === totalPages}
          variant="outline"
          size="sm"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default OrderPagination;